import { useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { IStore } from '../interfaces/Store'
import { DefaultJddAddress } from '../store/State/JddAddress'
import { SELECT_FIRST_OPTION } from '../components/step4/Options'
import { IOption } from '../interfaces/FormFields'
import { IAddressCityOption, IAddressSectionProps } from '../interfaces/Step4'
import useCityListHook from './useCityListHook'
import useResidentialCountriesListHook from './useResidentialCountriesListHook'

const useAddressSectionHook = (props: IAddressSectionProps) => {
  const { setValue, watch, setError, clearError } = props
  const { status, jddAddress } = useSelector(
    (state: IStore) => state.jddAddressReducer
  )
  const { adresse_pays, commune_habitation, adresse_ville } =
    jddAddress || DefaultJddAddress

  const [addressCountry, setAddressCountry] = useState<IOption>(
    SELECT_FIRST_OPTION
  )
  const {
    countriesStatus,
    residentialCountriesList,
  } = useResidentialCountriesListHook()
  const [addressCity, setAddressCity] = useState<IAddressCityOption>(
    SELECT_FIRST_OPTION
  )
  const [citiesStatus, cities] = useCityListHook(
    adresse_ville,
    watch,
    setError,
    clearError
  )

  useEffect(() => {
    const addressCountryValue = residentialCountriesList.find(
      (country) => country.value === adresse_pays
    )

    if (addressCountryValue) {
      setAddressCountry(addressCountryValue)
      setValue('adresse_pays', addressCountryValue.value)
    }
    // eslint-disable-next-line
  }, [adresse_pays, status, residentialCountriesList])

  useEffect(() => {
    const addressCityValue = cities.find(
      (city) => city.value === commune_habitation
    )
    if (addressCityValue && !addressCity.value) {
      setAddressCity(addressCityValue)
      setValue('commune_habitation', addressCityValue)
    }
    // eslint-disable-next-line
  }, [commune_habitation, addressCountry, cities])

  const handleOnChangeCountry = (selected: IOption | null) => {
    // @ts-ignore
    setAddressCountry(selected)
    setValue('adresse_pays', selected ? selected.value : '')
    return selected ? selected.value : selected
  }

  const handleOnChangeCity = (selected: IAddressCityOption | null) => {
    // @ts-ignore
    setAddressCity(selected)
    setValue('commune_habitation', selected || '')
    return selected
  }

  const getAddressVille = () => {
    return addressCity.label.split(' (')[0] // remove code from label eg. ABANCOURT (59) => ABANCOURT
  }

  return {
    status,
    jddAddress,
    handleOnChangeCountry,
    handleOnChangeCity,
    addressCountry,
    addressCity,
    cities,
    citiesStatus,
    getAddressVille,
    countriesStatus,
    residentialCountriesList,
  }
}

export default useAddressSectionHook
